import useFeatureIsAccessible from '@map/hooks/useFeatureIsAccessible';
import MixpanelProvider from '@shared/lib/mixpanel/context';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

const MapMixpanelProvider = ({ children }: Props) => {
  const isLite = useFeatureIsAccessible('isLite');

  return <MixpanelProvider isLite={isLite}>{children}</MixpanelProvider>;
};

export default MapMixpanelProvider;
